module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "upload-photo-wrapper",
    attrs: {
      "element-loading-text": "数据上传中，请不要离开当前页面"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("导入照片\n        "), _c('div', {
    staticClass: "header-buttons right_f"
  }, [_c('el-button', {
    staticClass: "record-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToImportRecord
    }
  }, [_vm._v("导入记录")]), _vm._v(" "), _c('el-button', {
    staticClass: "return-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "custom-upload-area",
    on: {
      "click": _vm.triggerFileInput,
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.handleDrop.apply(null, arguments)
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".zip"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload",
    staticStyle: {
      "font-size": "67px",
      "color": "#c0c4cc",
      "margin": "20px 0 16px"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "emergency-close"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.emergencyClose
    }
  }, [_vm._v("紧急关闭加载状态")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-container"
  }, [_c('h3', [_vm._v("照片上传要求")]), _vm._v(" "), _c('p', [_vm._v("照片保存为JPG格式，并将学生照片按照马甲号学生id命名（不可重复）。并打包压缩包，仅支持.ZIP文件上传。")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("(ZIP包大小不超过600M,单张不能超过2M)")]), _vm._v(" "), _c('p', [_vm._v("上传错误时，存在类型：")]), _vm._v(" "), _c('p', [_vm._v("(1) 马甲号学生id不存在")]), _vm._v(" "), _c('p', [_vm._v("(2) 照片格式错误")]), _vm._v(" "), _c('p', [_vm._v("(3) 照片过大")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#606266",
      "font-size": "14px",
      "text-align": "center",
      "margin": "0 0 20px"
    }
  }, [_vm._v("\n            将文件拖到此处，或"), _c('em', {
    staticStyle: {
      "color": "#409EFF",
      "font-style": "normal"
    }
  }, [_vm._v("点击上传")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fb77ef6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/photo/photoImport.vue
// module id = 943
// module chunks = 0